import { getAltTagProductPage } from "@faire/retailer-visitor-shared/features/Marketplace/utils";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { OpenSizingVariantTable } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/OpenSizingVariantTable";
import { SingleVariationSelector } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/SingleVariationSelector";
import { useVariantOptionSelectionViewState } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/useVariantOptionSelectionViewState";
import { ProductAddToCartState } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/useProductAddToCartState";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { observer } from "mobx-react";
import * as React from "react";
import { useMemo } from "react";

interface IProps {
  productAddToCartState: ProductAddToCartState;
  product: IProductPageResponse.IPdpProduct;
  brand: IProductPageResponse.IPdpBrand;
  isTablet: boolean;
}

const OptionSelectionBase: React.FC<IProps> = ({
  productAddToCartState,
  product,
  brand,
  isTablet,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const variantOptionSelectionViewState = useVariantOptionSelectionViewState(
    product,
    productAddToCartState
  );
  const { variationTypes, styleVariationTypes } =
    variantOptionSelectionViewState;

  const {
    isOpenSizingVariant,
    perStyleOptionVariations,
    perStyleTotalQuantity,
    minimumOrderQuantity,
    updateSelectedQuantityByToken,
  } = productAddToCartState;

  const isEnglish = useMemo(
    () => getLocaleKey()?.language === Language.ENG,
    []
  );

  const singleVariationSelectorAlt = useMemo(
    () => getAltTagProductPage(product, isEnglish, brand.name, strictLocalize),
    [brand.name, isEnglish, product, strictLocalize]
  );

  if (isOpenSizingVariant) {
    return (
      <>
        {styleVariationTypes.map((variation) => (
          <SingleVariationSelector
            key={variation.value}
            variationType={variation.type!}
            variationName={variation.value!}
            variationDisplayType={variation.display}
            variantOptionSelectionViewState={variantOptionSelectionViewState}
            alt={singleVariationSelectorAlt}
            brand={brand}
            isTablet={isTablet}
          />
        ))}
        <OpenSizingVariantTable
          brand={brand}
          product={product}
          perStyleOptionVariation={perStyleOptionVariations!}
          updateSelectedQuantityByToken={updateSelectedQuantityByToken}
          minimumOrderQuantity={minimumOrderQuantity}
          perStyleTotalQuantity={perStyleTotalQuantity}
        />
      </>
    );
  }

  return variationTypes.map((variation) => (
    <SingleVariationSelector
      key={variation.value}
      variationType={variation.type!}
      variationName={variation.value!}
      variationDisplayType={variation.display}
      variantOptionSelectionViewState={variantOptionSelectionViewState}
      brand={brand}
      isTablet={isTablet}
    />
  ));
};
export const OptionSelection = observer(OptionSelectionBase);
